export const headerMenuList = [{ name: 'Log in', url: '/auth/login' }];

export const footerMenuList = [
  { name: 'Terms of use', url: '/terms-of-use' },
  // { name: 'Privacy policy', url: '/privacy-policy' },
];
